import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './EmailConfirmationLink.styled';
import {
  EmailStatusWarningIcon,
  SmallChevronIcon,
} from '@/components/UI/Icons/Icons';
import { ROUTES } from '@/constants/routes';

type EmailConfirmationLinkProps = {
  email?: string | null;
  emailConfirmed?: boolean | null;
  className?: string;
};

export function EmailConfirmationLink({
  email,
  emailConfirmed,
  className,
}: EmailConfirmationLinkProps) {
  const { t } = useTranslation();
  const isVisible = !!email && emailConfirmed === false;

  if (!isVisible) return null;

  return (
    <S.Link className={className} href={ROUTES.settings}>
      <EmailStatusWarningIcon width={16} height={16} />
      <S.Text>{t('pages.cabinet.confirm_email')}</S.Text>
      <SmallChevronIcon width={7} height={12} />
    </S.Link>
  );
}
